module.exports = "/video-roulette/img/kvacica.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/kvacica.png
// module id = 2436
// module chunks = 10